interface InputDesignProps {
  bgColor?: string;
  hoverBgColor?: string;
  textColor?: string;
  textHoverColor?: string;
  label: string;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

function PrimaryButton({ onClick, label, type = 'button', bgColor, hoverBgColor, textColor, textHoverColor, className }: InputDesignProps) {
  return (
    <button type={type} onClick={onClick} className={`font-fractul ${bgColor} ${hoverBgColor} ${textColor} ${textHoverColor} ${className} px-5 h-[40px] md:h-[48px] rounded-full transition-colors duration-300 ease-in-out`}>
      {label}
    </button>
  );
}

export default PrimaryButton;
